<div class="dashboard-content" style="padding: 120px 40px 50px">
  <div class="billing-and-payments-screen">
    <div class="page-heading">
      <h3>
        {{ 'billing.invoicing' | translate }}
      </h3>
      <div class="heading-right">
        <div class="search">
          <input type="text" class="form-control" [placeholder]="'billing.search' | translate" [(ngModel)]="searchText"
            (input)="onSearch()" autocapitalize="off" style="text-transform: none;">
          <i class="fa-solid fa-magnifying-glass"></i>
        </div>
        <button class="btn btn-light filter-btn" (click)="openFilterModal()">
          <i class="fa-solid fa-filter"></i>
          <span>Filter</span>
          <span *ngIf="hasActiveFilters()" class="filter-active-dot"
            (click)="clearAllFilters(); $event.stopPropagation()" title="Click to clear filters">
          </span>
        </button>
        <div class="dropdown export-dropdown">
          <button class="btn btn-export dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
            {{ 'billing.export' | translate }}
          </button>
          <ul class="dropdown-menu dropdown-menu-end">
            <li>
              <a class="dropdown-item" href="javascript:void(0)" (click)="downloadInvoice()">
                <i class="fa-solid fa-file-pdf me-2" style="color: #e74c3c;"></i>
                PDF
              </a>
            </li>
            <li>
              <a class="dropdown-item" href="javascript:void(0)" (click)="downloadExcel()">
                <i class="fa-solid fa-file-excel me-2" style="color: #27ae60;"></i>
                Excel
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- table -->
    <div class="luqta-card">
      <div class="card-heading">
        <h3>
          {{ 'billing.billingAndInvoice' | translate }} ({{ totalItems }})
        </h3>
      </div>
      <nz-table #contestTable [nzData]="filteredInvoice" [nzBordered]="true" [nzScroll]="{ x: '1500px' }"
        [nzShowSizeChanger]="true" [nzPageSize]="pageSize" [nzPageIndex]="pageIndex" [nzTotal]="totalItems"
        [nzPageSizeOptions]="[10, 20, 50]" [nzShowPagination]="true" [nzFrontPagination]="false"
        (nzPageIndexChange)="onPageIndexChange($event)" (nzPageSizeChange)="onPageSizeChange($event)">
        <thead>
          <tr>
            <th nzWidth="150px">{{ 'billing.table.invoiceId' | translate }}</th>
            <!-- <th nzWidth="130px">Created Date</th> -->
            <th nzWidth="120px">{{ 'billing.table.startDate' | translate }}</th>
            <th nzWidth="120px">{{ 'billing.table.endDate' | translate }}</th>
            <th nzWidth="120px">{{ 'billing.table.planType' | translate }}</th>
            <th nzWidth="100px">{{ 'billing.table.mode' | translate }}</th>
            <th nzWidth="130px">{{ 'billing.table.paidAmount' | translate }}</th>
            <th nzWidth="140px">Payment Method</th>
            <th nzWidth="150px">{{ 'billing.table.contestAllowed' | translate }}</th>
            <th nzWidth="150px">{{ 'billing.table.paymentStatus' | translate }}</th>
            <th nzWidth="80px" nzRight>Download</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of contestTable.data">
            <td style="text-transform: none;" [innerHTML]="data.id | highlight: searchText"></td>
            <!-- <td style="text-transform: none;" [innerHTML]="data.created_date | highlight: searchText"></td> -->
            <td style="text-transform: none;" [innerHTML]="data.start_date | highlight: searchText"></td>
            <td style="text-transform: none;" [innerHTML]="data.end_date | highlight: searchText"></td>
            <td style="text-transform: none;" [innerHTML]="data.plan_type | highlight: searchText"></td>
            <td style="text-transform: none;" [innerHTML]="data.mode | highlight: searchText"></td>
            <td style="text-transform: none;" [innerHTML]="data.paid_amount | highlight: searchText"></td>
            <td style="text-transform: none;" [innerHTML]="data.payment_method | highlight: searchText"></td>
            <td style="text-transform: none;" [innerHTML]="data.contest_allowed | highlight: searchText"></td>
            <td style="text-transform: none;">
              <span [ngClass]="getStatusClass(data.payment_status)"
                [innerHTML]="data.payment_status | highlight: searchText"></span>
            </td>
            <td nzRight style="text-align: center;">
              <button class="btn btn-sm" (click)="downloadSingleInvoice(data)" title="Download Invoice"
                style="background: none; border: none; cursor: pointer;">
                <i class="fa-solid fa-download" style="color: #2c3e50; font-size: 16px;"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>


    <!-- Payment Methods Section - Hidden for now -->
    <!-- <div class="current-payments-accounts-card">
      <div class="content">
        <img src="../../../../assets/images/accounts.png" alt="">
        <h4>
          {{ 'billing.paymentMethods' | translate }}
        </h4>
        <p>
          {{ 'billing.paymentMethodsDesc' | translate }}
        </p>
      </div>
      <div class="accounts">
        <h3>
          {{ 'billing.currentPaymentAccounts' | translate }}
        </h3>
        <div class="account-card" *ngFor="let card of cardList; trackBy: trackByCardId">
          <div class="cards-detail">
            <div class="logo">
              <img src="../../../../assets/images/mastercard.svg" alt="">
            </div>
            <span>
              {{ card.card_number | maskLast4 }}
            </span>
          </div>
          <div class="action-btns">
            <ng-container *ngIf="card.set_primary">
              <button class="btn btn-default">{{ 'billing.buttons.default' | translate }}</button>
              <button class="btn btn-edit" (click)="editCard(card.id)">{{ 'billing.buttons.edit' | translate }}</button>
            </ng-container>
            <ng-container *ngIf="!card.set_primary">
              <button class="btn btn-make-default" (click)="showConfirm(card)">{{ 'billing.buttons.makeDefault' |
                translate }}</button>
              <button class="btn btn-remove" (click)="deleteCard(card)">{{ 'billing.buttons.remove' | translate
                }}</button>
              <button class="btn btn-edit" (click)="editCard(card.id)">{{ 'billing.buttons.edit' | translate }}</button>
            </ng-container>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</div>

<!-- Filter Modal -->
<app-filter-modal [(isVisible)]="filterModalVisible" [config]="filterConfig" [modalTitle]="'Filter Billing'"
  [initialFilters]="currentFilters" (filtersApplied)="onFiltersApplied($event)"
  (filtersReset)="onFiltersReset()"></app-filter-modal>